export function numberWithCommas(number){
    if (isNaN(number)) return ''; // Return empty if the input is not a number
    return Number(number).toLocaleString('en-US'); // Convert
}